export default "__VITE_ASSET__db1ef0fd__"